'use client';
import React, { useEffect } from 'react';
import { useStickyBox } from 'react-sticky-box';
import { ExchangeNode } from '@/types/global';
import { Exchange } from '@/types/exchanges/page';
import { LayoutProps } from '@/types/generalSettings';
import BannerSidebar from '@/components/(features)/bannerSidebar';
import useStoreID from '@/stores/admin/IDStore';

interface SingleBrokerMainProps {
    banners?: LayoutProps.Banners | undefined;
    post?: ExchangeNode;
    categories?: 'foreign' | 'iranian' | 'props' | 'broker' | undefined;
    iranianExchanges?: Exchange[];
    foreignExchanges?: Exchange[];
    brokers?: Exchange[];
}

const Aside: React.FC<SingleBrokerMainProps> = ({ post, banners }) => {
    const stickyRef = useStickyBox({ offsetTop: 100, offsetBottom: 20 });
    const { setPostId } = useStoreID();

    useEffect(() => {
        if (post?.databaseId) {
            setPostId(post.databaseId);
        }
    }, [post, setPostId]);

    return (
        <aside className={'lg:col-span-3 max-xl:col-span-12 lg:pr-3 mt-2'}>
            <div ref={stickyRef}>
                <BannerSidebar banners={banners} />
            </div>
        </aside>
    );
};

export default Aside;
